import { render, staticRenderFns } from "./AccordionCard.vue?vue&type=template&id=a8fecb12&scoped=true&"
import script from "./AccordionCard.vue?vue&type=script&lang=js&"
export * from "./AccordionCard.vue?vue&type=script&lang=js&"
import style0 from "./AccordionCard.vue?vue&type=style&index=0&id=a8fecb12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fecb12",
  null
  
)

export default component.exports